// Leaf module (imports nothing) so both utils.js and billingRules.js can use the units
// clamp without importing each other. billingRules.js re-exports both names.

// Units are a free count (1..MAX_UNITS); oncology drug lines routinely bill hundreds.
export const MAX_UNITS = 1000;

// Units input read: null for empty/garbage (caller keeps the previous value), otherwise a
// whole number clamped to 1..MAX_UNITS.
export function clampUnits(value) {
  if (value == null || typeof value === "boolean") return null;
  if (typeof value === "string" && value.trim() === "") return null;
  const n = Number(typeof value === "string" ? value.trim() : value);
  if (!Number.isFinite(n)) return null;
  return Math.min(MAX_UNITS, Math.max(1, Math.round(n)));
}
